import { convertSnakeToCamelCase } from 'utils/convertSnakeToCamelCase';
import { convertCamelToSnakeCase } from 'utils/convertCamelToSnakeCase';

export const normalizeAppointmentServiceType = convertSnakeToCamelCase;

export const denormalizeAppointmentServiceType = convertCamelToSnakeCase;
